import React from 'react'
import { Button, Input } from 'antd'
import styled from 'styled-components'

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
export const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`
export const InputLabel = styled.p`
  margin: 0 8px 0 0;
  width: 140px;
  text-align: right;
`

interface IValidator {
  pubkey: string
  signature: string
  deposit_data_root: string
}

interface IFileContent {
  fileContent: IValidator[]
  uploadNewFile: () => void
  tokenInfo: any
}

export const FileContent = ({
  fileContent,
  uploadNewFile,
  tokenInfo,
}: IFileContent) => {
  return (
    <ContentWrapper>
      <InputWrapper>
        <InputLabel>Number of validators:</InputLabel>
        <Input value={fileContent.length} disabled style={{ width: 232 }} />
      </InputWrapper>
      <InputWrapper>
        <InputLabel>Cost:</InputLabel>
        <Input
          value={`${fileContent.length} ${tokenInfo.symbol}`}
          disabled
          style={{ width: 232 }}
        />
      </InputWrapper>
      <Button
        style={{ width: 155, marginTop: 18 }}
        ghost
        type="primary"
        onClick={uploadNewFile}
      >
        Upload different file
      </Button>
    </ContentWrapper>
  )
}
